import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { setBreakpoint } from 'app/shared/modules/globalEvents/actions';
import { GlobalEventHandlers } from 'app/shared/modules/globalEvents/GlobalEventHandlers/GlobalEventHandlers';
import { breakpointSelector } from '../selectors';

const mapStateToProps = createStructuredSelector({
  breakpoint: breakpointSelector,
});

export const ConnectedGlobalEventHandlers = connect(mapStateToProps, {
  setBreakpoint,
})(GlobalEventHandlers);
